import { decreaseLumaDelta } from '../util';
import { graphAxisLines, graphWallFill } from './';
export const graphGridLines = (theme, parameters) => {
  const common = {
    lineThickness: graphAxisLines(theme, parameters).lineThickness
  };
  switch (theme.baseThemeName) {
    case 'dark':
      {
        return {
          ...common,
          lineColor: graphAxisLines(theme, parameters).lineColor,
          lineStyle: 'dot',
          lineTransparency: 0.6,
          gridLayer: 'front'
        };
      }
    case 'high-contrast':
      {
        return {
          ...common,
          lineColor: decreaseLumaDelta(graphAxisLines(theme, parameters).lineColor, graphWallFill(theme, parameters).fillColor, 41, true),
          lineStyle: 'shortdash',
          lineTransparency: 0,
          gridLayer: 'back'
        };
      }
    default:
      {
        return {
          ...common,
          lineColor: graphAxisLines(theme, parameters).lineColor,
          lineStyle: 'dot',
          lineTransparency: 0.6,
          gridLayer: 'front'
        };
      }
  }
};
//# sourceMappingURL=graphGridLines.js.map